module.exports = __webpack_public_path__ + "static/media/hpm-image-5.c2d5c87d.jpeg";